import { Button, Tooltip } from "antd";
import { useContext } from "react";
import {
  LiveTrackIcon,
  ManualTrackIcon,
} from "../../../../../assets/icons/CustomIcons";
import { TrackerContext } from "./utils/types";
const TrackerModeSwitch = () => {
  const { typeOfTracking, switchTracker } = useContext(TrackerContext);
  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 0,
        }}
      >
        <Tooltip title="Track time live" placement="left">
          <Button
            onClick={() => switchTracker("Auto")}
            style={{
              border: "none",
              boxShadow: "none",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 24,
              height: 22,
              minWidth: 24,
              padding: 0,
            }}
          >
            <span
              style={{
                display: "flex",
                width: 14,
                height: 14,
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <LiveTrackIcon
                color={typeOfTracking === "Auto" ? "#137AE9" : "#bbb"}
              />
            </span>
          </Button>
        </Tooltip>
        <Tooltip title="Track time manually" placement="left">
          <Button
            onClick={() => switchTracker("Manual")}
            style={{
              border: "none",
              boxShadow: "none",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 24,
              height: 22,
              minWidth: 24,
              padding: 0,
            }}
          >
            <span
              style={{
                display: "flex",
                width: 14,
                height: 14,
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <ManualTrackIcon
                color={typeOfTracking === "Manual" ? "#137AE9" : "#bbb"}
              />
            </span>
          </Button>
        </Tooltip>
        {/* <Button
          style={{ border: "none" }}
          onClick={() => switchTracker("Calendar")}
        >
          <CalendarOutlined
            color={typeOfTracking === "Calendar" ? "#137AE9" : "gray"}
            style={{
              //FONT SIZE TO CHANGE THE ACTUAL ICON SIZE
              fontSize: 20,
              color: typeOfTracking === "Calendar" ? "#137AE9" : "gray",
              strokeWidth: "40px",
              stroke: typeOfTracking === "Calendar" ? "#137AE9" : "gray",
            }}
          />
        </Button> */}
      </div>
    </>
  );
};
export default TrackerModeSwitch;
